export class VerificationResponse {
  public attempts: number = 0;

  constructor(
    public success: boolean,
    public error: string,
    public method: string
  ) {}
}
